var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body } from "syf-component-library/ui/typography";
import i18n from "../../strings/i18n";
import { useConfig } from "../../hooks/useConfig";
import { CardImage } from "../../ui/atoms/AccountImage/AccountImage.style";
import { ErrorBody, ErrorImageWrapper, ErrorInfo, ErrorTitle, } from "./ErrorWrapper.styles";
import { IMAGE_API_FAILURE } from "../../const/assets";
var ErrorComponent = function () {
    var hosts = useConfig().hosts;
    var imageSource = "".concat(hosts === null || hosts === void 0 ? void 0 : hosts.assets).concat(IMAGE_API_FAILURE);
    return (_jsxs(ErrorBody, { children: [_jsx(ErrorImageWrapper, { children: _jsx(CardImage, { src: imageSource, alt: "API Failure" }) }), _jsxs(ErrorInfo, { children: [_jsx(ErrorTitle, __assign({ weight: "bold" }, { children: i18n({ error: "title" }) })), _jsx(Body, { children: i18n({ error: "subTitle" }) })] })] }));
};
export default ErrorComponent;
//# sourceMappingURL=ErrorComponent.js.map